import FiscaliteScreen, { fmt } from './FiscaliteScreen';
import axiosInstance from '../../../variables/api/axiosInstance';
import { frenchDate } from '../../../variables/functions';

// TCA à reverser : listing des encaissements de primes d'un mois, avec la taxe (TCA = c.taxes) en
// exergue. Endpoint dédié /api/reglement/tca (renvoie la TCA du contrat, absente de /api/reglement).
const num = (n) => Number(n) || 0;

const TcaAReverser = () => {
    const fetchRows = (start, end, compagnie) =>
        axiosInstance.get('/api/reglement/tca', { params: { startDate: start, endDate: end, compagnie: compagnie || undefined } })
            .then((r) => r.data || []);

    const columns = [
        { title: 'N° Police', key: 'police', render: (_, r) => r.numeroPolice || r.police || '—' },
        { title: 'Souscripteur', key: 'sous', render: (_, r) => `${r.nomSouscripteur || ''} ${r.prenomSouscripteur || ''}`.trim() || '—' },
        { title: 'Catégorie', dataIndex: 'categorie', render: (v) => v || '—' },
        { title: 'Date règlement', dataIndex: 'dateReglement', render: (v) => v ? frenchDate(v) : '—' },
        { title: 'Prime (FCFA)', dataIndex: 'montant', align: 'right', render: (v) => fmt(v) },
        {
            title: 'TCA (FCFA)', dataIndex: 'taxes', align: 'right',
            render: (v) => <b style={{ color: '#242166', fontVariantNumeric: 'tabular-nums' }}>{fmt(v)}</b>,
            sorter: (a, b) => num(a.taxes) - num(b.taxes),
        },
    ];

    const kpis = (rows) => [
        { label: 'Encaissements', value: rows.length },
        { label: 'Primes encaissées', value: rows.reduce((a, r) => a + num(r.montant), 0), money: true },
        { label: 'TCA à reverser', value: rows.reduce((a, r) => a + num(r.taxes), 0), money: true, highlight: true, sub: 'à reverser à l\'État' },
    ];

    const exportColumns = [
        { header: 'N° Police', accessor: (r) => r.numeroPolice || r.police || '' },
        { header: 'Souscripteur', accessor: (r) => `${r.nomSouscripteur || ''} ${r.prenomSouscripteur || ''}`.trim() },
        { header: 'Catégorie', accessor: (r) => r.categorie || '' },
        { header: 'Date règlement', accessor: (r) => (r.dateReglement ? frenchDate(r.dateReglement) : '') },
        { header: 'Prime (FCFA)', accessor: (r) => num(r.montant), money: true },
        { header: 'TCA (FCFA)', accessor: (r) => num(r.taxes), money: true },
    ];

    return (
        <FiscaliteScreen
            title="TCA à reverser"
            subtitle="Taxe sur les contrats d'assurance — encaissements du mois"
            fetchRows={fetchRows}
            kpis={kpis}
            columns={columns}
            exportColumns={exportColumns}
            enableAnnual
            pdfTitle="TCA À REVERSER"
            fileBase="TCA_a_reverser"
        />
    );
};

export default TcaAReverser;
